import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const TipiContattiContext = React.createContext(null);

const { Provider } = TipiContattiContext;

export const TipiContattiProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        tipi: { result: [], totalCount: 0, },
    });

    const { tipi } = state;

    const [isLoadingTipiContatti, setIsLoadingTipiContatti] = useState(false);
    const getTipiContattiAsync = async (pageIndex = 0, pageSize = 100, term = null, valid = false, padre = true,) => {
        try {
            setIsLoadingTipiContatti(true);
            const r = await fetchAuthorized(ApiRoutes.TipoContatto.GetTipiContatti({ pageIndex, pageSize, padre, term, valid }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, inizioValidita: new Date(e.inizioValidita), fineValidita: e.fineValidita ? new Date(e.fineValidita) : null, } });
            setState({ tipi: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipiContatti(false);
        }
    }

    const [isDeletingTipoContatto, setIsDeletingTipoContatto] = useState(false);
    const deleteTipoContattoAsync = async (tipoContattoId,) => {
        try {
            setIsDeletingTipoContatto(true);
            if (window.confirm("Confermare l'eliminazione?")) {
                const r = await fetchAuthorized(ApiRoutes.TipoContatto.DeleteTipoContatto({ tipoContattoId }), {
                    method: HttpMethods.DELETE
                });
                const list = tipi.result;
                list.forEach(x => {
                    if (x.id == tipoContattoId)
                        x.fineValidita = new Date();
                });
                setState({
                    tipi: {
                        ...tipi, result: list
                    }
                });
                showSuccessMessage(`Tipo con id ${tipoContattoId} disabilitato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingTipoContatto(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingTipiContatti,
            getTipiContattiAsync,

            isDeletingTipoContatto,
            deleteTipoContattoAsync,
        }}>
            {props.children}
        </Provider>
    );
}